import React from 'react';
import Icon from 'components/general/Icon/Icon';

const Banner: React.SFC<PropDef> = (props) => {
  const {
    icon,
    message,
    renderMessage,
  } = props;

  return (
    <div className="banner">
      {icon && (
        <Icon name={icon} />
      )}
      <div className="banner__message">
        {renderMessage ? renderMessage() : message}
      </div>
    </div>
  );
};

interface PropDef {
  icon?: string;
  message?: string;
  renderMessage?();
}

export default Banner;
